import { Form } from 'antd';
import React from 'react'
import InputMask from 'react-input-mask';

const InputMaskUC = (props) => {
    const {
        name,
        label,
        isCustomError = false,
        labelError = null,
        showLabel = true,
        type = "text",
        onChange,
        values,
        maxLength,
        suffix,
        required,
        disabled,
        hidden,
        mask = "9-9999-99999-99-9",
        maskChar = "",
        ...prop } = props;

    return (
        <>
            <Form.Item
                name={name}
                label={showLabel ? (label + ' :') : ''}
                rules={required ? [{
                    required: true,
                    message: 'กรุณากรอก ' + label
                }, {
                    validator: (_, value) =>
                        (typeof (name) === 'string' && name.toString().toLowerCase().includes("code")) ? (
                            !value || !value.toString().includes(' ')
                                ? Promise.resolve()
                                : Promise.reject(new Error(label + ' ไม่สามารถมีช่องว่าง'))
                        ) : Promise.resolve()
                }] : ''
                }
                validateStatus={(isCustomError && required) ? 'error' : undefined}
                help={(isCustomError && required) ? labelError : null}
                initialValue={values ? values : ''}
            >
                <InputMask
                    {...prop}
                    maskChar={maskChar}
                    className="ant-input input-mask-rc"
                    mask={mask}
                    type={type}
                    disabled={disabled}
                    onChange={onChange}
                    suffix={suffix ? suffix : ''}
                    onKeyPress={(ev) => {
                        if (ev.key === "Enter" || (ev.key === " " && name.toLowerCase().includes("code"))) {
                            ev.preventDefault();
                            console.log(ev.target.value);
                        }
                    }}
                />
            </Form.Item>
        </>
    )
}

export default InputMaskUC